export const VALIDATE_LOGIN_USERNAME = "login_form/VALIDATE_LOGIN_USERNAME";

export default function validateLoginUsernameAction() {
  return {
    "payload": {},
    "type": VALIDATE_LOGIN_USERNAME
  };
}
